import React from 'lib/react';
import Typography from 'commonComponents/typography';
import { useSelector } from 'lib/redux';
import PropTypes from 'prop-types';
import { getHighlightedText } from '../OrderHistory.utils';

// Property Data field labels mapping based on API response structure
const PROPERTY_DATA_FIELDS = {
  RoofAge: 'Roof Age',
  RoofAreaEstimate: 'Roof Area Estimate',
  RoofAgeReason: 'Roof Age Reason',
  RoofCondition: 'Roof Condition',
  PredominantPitch: 'Predominant Pitch',
  MinEaveHeight: 'Min Eave Height',
  MaxEaveHeight: 'Max Eave Height',
  RoofMaterial: 'Roof Material',
  SolarPanels: 'Solar Panels',
  RoofFacetCount: 'Roof Facet Count',
  StructureCount: 'Structure Count',
  // Fallback for any additional fields not specifically mapped
  propertyType: 'Property Type',
  yearBuilt: 'Year Built',
  lotSize: 'Lot Size',
  buildingArea: 'Building Area',
  numberOfUnits: 'Number of Units',
  numberOfBedrooms: 'Number of Bedrooms',
  numberOfBathrooms: 'Number of Bathrooms',
  garageType: 'Garage Type',
  garageSpaces: 'Garage Spaces',
  heatingType: 'Heating Type',
  coolingType: 'Cooling Type',
  exteriorWalls: 'Exterior Walls',
  foundationType: 'Foundation Type',
  poolType: 'Pool Type',
  fireplaces: 'Fireplaces',
  stories: 'Stories',
  basement: 'Basement',
  atticType: 'Attic Type',
  waterSource: 'Water Source',
  sewerType: 'Sewer Type',
  utilities: 'Utilities',
  zoning: 'Zoning',
  landUse: 'Land Use',
  ownerOccupied: 'Owner Occupied',
  marketValue: 'Market Value',
  assessedValue: 'Assessed Value',
  taxAmount: 'Tax Amount',
  mortgageAmount: 'Mortgage Amount',
  saleDate: 'Last Sale Date',
  salePrice: 'Last Sale Price',
};

function PropertyDataSection({ propertyData }) {
  const { searchText } = useSelector(({ orderHistory }) => ({ searchText: orderHistory.searchText }));

  if (!propertyData || Object.keys(propertyData).length === 0) {
    return null;
  }

  return (
    <div style={{ padding: '0px 8px 8px' }}>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '24px',
        alignItems: 'flex-start',
      }}
      >
        {Object.keys(propertyData).map((key) => (
          propertyData[key] && (
            <div key={key} style={{ minWidth: '200px', flex: '0 0 auto' }}>
              <Typography
                style={{
                  textTransform: 'uppercase',
                  fontFamily: 'Noto Sans',
                  fontWeight: 600,
                  fontSize: '12px',
                  lineHeight: '18px',
                  fontColor: '#1B202C',
                }}
              >
                {PROPERTY_DATA_FIELDS[key] || key}
              </Typography>
              <Typography
                style={{
                  fontFamily: 'Noto Sans',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '18px',
                  fontColor: '#61687D',
                }}
              >
                {getHighlightedText(propertyData[key], searchText)}
              </Typography>
            </div>
          )
        ))}
      </div>
    </div>
  );
}

PropertyDataSection.propTypes = {
  propertyData: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
};

PropertyDataSection.defaultProps = {
  propertyData: null,
};

export default PropertyDataSection;
